import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Box, Switch, FormControlLabel, Typography } from "@mui/material";
import GiftSection from "./GiftSection";

const CouponSection = forwardRef((props, ref) => {
  const [couponCode, setCouponCode] = useState("");
  const [isActive, setIsActive] = useState(true);
  const giftSectionRef = useRef();
  const { error, giftTypes = [] } = props;

  useImperativeHandle(ref, () => ({
    getCouponData: () => {
      return {
        coupon: {
          code: couponCode,
          is_active: isActive ? 1 : 0,
        },
      };
    },
    getGiftData: () => {
      return giftSectionRef.current
        ? giftSectionRef.current.getGiftData()
        : {
            rewards: {
              promotion_gift_types: [],
              free_products: [],
            },
          };
    },
    reset: () => {
      setCouponCode("");
      setIsActive(true);
      if (giftSectionRef.current) {
        giftSectionRef.current.reset();
      }
    },
  }));

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      gap={3}
      p={{ xs: 1, sm: 2, md: 3 }}
      boxShadow={3}
      borderRadius={4}
      bgcolor="#fff"
      mb={4}
      sx={{
        width: { xs: "100%", md: "90%" },
        margin: "20px auto",
        backgroundColor: "#fff !important",
      }}
    >
      <MDTypography variant="h6" fontWeight="bold" mb={0}>
        بيانات الكوبون
      </MDTypography>
      <MDBox
        display="flex"
        gap={2}
        alignItems="center"
        width="100%"
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <MDInput
          label="كود الكوبون"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          sx={{ flex: 2, width: { xs: "100%", sm: "auto" } }}
          fullWidth
          inputProps={{ dir: "rtl" }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label="تفعيل الكوبون"
          sx={{ ml: 0, width: { xs: "100%", sm: "auto" } }}
        />
      </MDBox>
      {error && (
        <Typography color="error" fontSize={13}>
          {error}
        </Typography>
      )}
      <GiftSection ref={giftSectionRef} error={props.rewardsError} giftTypes={giftTypes} />
    </MDBox>
  );
});

export default CouponSection;
